import React from 'react'
import { Form, Input, Button } from 'antd'
import { func } from 'prop-types'

import { useCreateGoal } from '@graphql/mutations'

function ManageGoalForm({ afterSubmit }) {
  const [form] = Form.useForm()
  const [createGoal, { loading }] = useCreateGoal()

  const onFinish = data => {
    createGoal({
      variables: {
        data: { ...data },
      },
      refetchQueries: ['GetGoalsQuery'],
    }).then(callback => afterSubmit(callback), form.resetFields())
  }

  return (
    <Form onFinish={onFinish} form={form}>
      <Form.Item
        name="name"
        rules={[
          {
            required: true,
            message: `Campo obrigatório`,
          },
        ]}
        hasFeedback
      >
        <Input placeholder="Nome da finalidade" size="large" autoFocus />
      </Form.Item>

      <Button
        type="primary"
        htmlType="submit"
        size="large"
        disabled={loading}
        block
      >
        Criar finalidade
      </Button>
    </Form>
  )
}

ManageGoalForm.propTypes = {
  afterSubmit: func,
}

ManageGoalForm.defaultProps = {
  afterSubmit: null,
}

export default ManageGoalForm
